import { apiInterceptor } from './ApiInterceptor';
import { URI } from '@/types/enum/api.enum';

export interface CitationRequest {
  [key: string]: unknown;
}

export interface CitationResponse {
  pdfUrl?: string;
  pdfData?: string;
  error?: string;
  success: boolean;
  content?: string; // For direct PDF content response
}

class CitationService {
  private static instance: CitationService;

  private constructor() {}

  public static getInstance(): CitationService {
    if (!CitationService.instance) {
      CitationService.instance = new CitationService();
    }
    return CitationService.instance;
  }

  /**
   * Fetch PDF citation for given data, returns a Blob
   * @param data - Object containing KEY:VALUE pairs from parsed button data
   */
  public async fetchCitation(data: Record<string, unknown>): Promise<Blob> {
    // Use apiInterceptor to fetch as blob
    return await apiInterceptor.post(URI.CITATIONS, data, { responseType: 'blob' });
  }
}

export const citationService = CitationService.getInstance();
